import { TUTORIAL_MODAL_WINDOW } from "@utils/index";
import { TutorialInterface } from "@interfaces/index";

export const dataTutorials: TutorialInterface[] = [
  {
    name: "assetCreateTutorial",
    label: "How to add a vehicle?",
    description:
      "Add a vehicle to your business — registration, purchase type, date, and cost. Optionally save it as your default asset.",
    items: [
      {
        element: TUTORIAL_MODAL_WINDOW,
        text: (
          <>
            <div className="text-black-100">
              <strong className="text-300">“Assets” in the FBTC Portal</strong>
              <br />
              <br />
              To help you get started, we’ve prepared a short tutorial that
              walks you through the process step by step.
              <br />
              <br />
              It’s quick and easy to complete, and will help you make the most
              of the new functionality.
            </div>
          </>
        ),
        modalWindowHeight: "h-1/3",
      },
      {
        element: "navigation_assets",
        text: (
          <>
            On the main navigational bar, select <strong>"Assets"</strong>.
          </>
        ),
        textPositionMobile: "top",
        afterClickNext: {
          redirect: "/assets",
        },
      },
      {
        element: "button_addAsset",
        text: (
          <>
            Then click the <strong>"Add Asset"</strong> button.
          </>
        ),
        textPosition: "left",
        afterClickNext: {
          clickOnElement: true,
        },
      },
      {
        element: "input_businessId",
        text: <>Please select the business you wish to add asset for.</>,
        textPosition: "left",
      },
      {
        element: "input_assetType",
        text: (
          <>
            Choose <strong>“Asset Type”</strong>: Vehicle.
          </>
        ),
        textPosition: "left",
      },
      {
        element: "input_registrationNumber",
        text: (
          <>
            Enter <strong>“Vehicle Registration Number”</strong>. It will be set
            as a vehicle asset name.
          </>
        ),
        textPosition: "left",
      },
      {
        element: "input_purchaseType",
        text: (
          <>
            Choose the <strong>“Purchase Type”</strong>: Outright, Hire Purchase
            (HP), Personal Contract Purchase (PCP), Loan, or Lease.
          </>
        ),
        textPosition: "left",
      },
      {
        element: "input_purchaseDate",
        text: (
          <>
            Enter <strong>“Purchase/Lease Date”</strong> and{" "}
            <strong>“Cost”</strong> (if not leased)
          </>
        ),
        textPosition: "left",
      },
      {
        element: "input_comment",
        text: (
          <>
            Add <strong>“Comments”</strong> (if needed).
          </>
        ),
        textPosition: "left",
        textPositionMobile: "top",
      },
      {
        element: "button_saveAsset",
        text: (
          <>
            <strong>"Save asset"</strong>. You can also choose to{" "}
            <strong>"Save as Default Asset”</strong>. It will appear preselected
            in the “Motor” expense transactions, for example, or when logging
            Mileage.
          </>
        ),
        textPosition: "top",
        textPositionMobile: "top",
      },
    ],
  },
  {
    name: "assetEditTutorial",
    label: "How to edit an asset?",
    description:
      "Update the business, registration, purchase type, dates, or cost on an existing asset.",
    items: [
      {
        element: TUTORIAL_MODAL_WINDOW,
        text: (
          <>
            <div className="text-black-100">
              <strong className="text-300">“Assets” in the FBTC Portal</strong>
              <br />
              <br />
              To help you get started, we’ve prepared a short tutorial that
              walks you through the process step by step.
              <br />
              <br />
              It’s quick and easy to complete, and will help you make the most
              of the new functionality.
            </div>
          </>
        ),
        modalWindowHeight: "h-1/3",
      },
      {
        element: "tr_assetsTable",
        text: <>Click through an asset from the grid.</>,
        textPosition: "top",
        textPositionMobile: "top",
        afterClickNext: {
          clickOnElement: true,
        },
      },
      {
        element: "button_editAsset",
        text: (
          <>
            Click the <strong>"Edit Asset"</strong> button.
          </>
        ),
        textPosition: "top",
        textPositionMobile: "top",
        afterClickNext: {
          clickOnElement: true,
        },
      },
      {
        element: "input_businessId",
        text: <>You can edit the business if needed.</>,
        textPosition: "left",
      },
      {
        element: "input_assetType",
        text: <>Update asset type.</>,
        textPosition: "left",
      },
      {
        element: "input_registrationNumber",
        text: <>Update Vehicle Registration Number.</>,
        textPosition: "left",
      },
      {
        element: "input_purchaseType",
        text: <>Update Purchase Type.</>,
        textPosition: "left",
        textPositionMobile: "top",
      },
      {
        element: "input_purchaseDate",
        text: <>Update Purchase/Lease Date and Cost.</>,
        textPosition: "left",
        textPositionMobile: "top",
      },
      {
        element: "input_comment",
        text: (
          <>
            You can leave or update a comment if needed; this field is optional.
          </>
        ),
        textPosition: "left",
        textPositionMobile: "top",
      },
      {
        element: "button_saveAsset",
        text: <>Now you can save the entry.</>,
        textPosition: "top",
        textPositionMobile: "top",
      },
    ],
  },
  {
    name: "assetDisposeTutorial",
    label: "How to dispose of an asset?",
    description:
      "Record a disposal — set the disposal date and amount, then remove the asset from your business.",
    items: [
      {
        element: TUTORIAL_MODAL_WINDOW,
        text: (
          <>
            <div className="text-black-100">
              <strong className="text-300">“Assets” in the FBTC Portal</strong>
              <br />
              <br />
              To help you get started, we’ve prepared a short tutorial that
              walks you through the process step by step.
              <br />
              <br />
              It’s quick and easy to complete, and will help you make the most
              of the new functionality.
            </div>
          </>
        ),
        modalWindowHeight: "h-1/3",
      },
      {
        element: "tr_assetsTable",
        text: <>Click through an asset from the grid.</>,
        textPosition: "top",
        textPositionMobile: "top",
        afterClickNext: {
          clickOnElement: true,
        },
      },
      {
        element: "button_disposeAsset",
        text: (
          <>
            Click <strong>"Remove from Business"</strong> button.
          </>
        ),
        textPosition: "top",
        textPositionMobile: "top",
        afterClickNext: {
          clickOnElement: true,
        },
      },
      {
        element: "input_disposalDate",
        text: <>Select Disposal Date.</>,
        textPosition: "left",
      },
      {
        element: "input_disposalAmount",
        text: <>Enter Disposal Amount.</>,
        textPosition: "left",
      },
      {
        element: "input_disposalComment",
        text: (
          <>
            You can leave or update a comment if needed; this field is optional.
          </>
        ),
        textPosition: "left",
        textPositionMobile: "top",
      },
      {
        element: "input_uploadFiles",
        text: <>You can upload files if needed; this field is optional.</>,
        textPosition: "left",
        textPositionMobile: "top",
      },
      {
        element: "button_removeAsset",
        text: <>Now you can save the entry.</>,
        textPosition: "top",
        textPositionMobile: "top",
      },
    ],
  },
  {
    name: "mileageCreateTutorial",
    label: "How to log mileage?",
    description:
      "Claim business mileage — pick the tax year and date range, choose the asset, and enter your miles.",
    items: [
      {
        element: TUTORIAL_MODAL_WINDOW,
        text: (
          <>
            <div className="text-black-100">
              <strong className="text-300">"Mileage” in the FBTC Portal</strong>
              <br />
              <br />
              To help you get started, we’ve prepared a short tutorial that
              walks you through the process step by step.
              <br />
              <br />
              It’s quick and easy to complete, and will help you make the most
              of the new functionality.
            </div>
          </>
        ),
        modalWindowHeight: "h-1/3",
      },
      {
        element: "navigation_mileage",
        text: (
          <>
            On the main navigational bar, select <strong>"Mileage Log"</strong>.
          </>
        ),
        textPositionMobile: "top left",
        afterClickNext: {
          redirect: "/mileage",
        },
      },
      {
        element: "mileage_select_businessId",
        text: <>Please select the business you wish to log mileage for</>,
      },
      {
        element: "button_logMileage",
        text: (
          <>
            Then click <strong>"Log Mileage"</strong>.
          </>
        ),
        textPosition: "left",
        afterClickNext: {
          clickOnElement: true,
        },
      },
      {
        element: "input_taxYear",
        text: (
          <>
            <strong>“Tax Year”</strong> is always set to the current Tax Year.
            In case you want to enter historical data, you can select the
            previous Tax years (if applicable) from a dropdown.
          </>
        ),
        textPosition: "left",
      },
      {
        element: "input_dateRange",
        text: (
          <>
            <strong>Date Range:</strong> Select the date range you want to enter
            Mileage for. Please note that you can enter the date range that
            falls into the selected Tax Year and your reporting period only.
            Also, you can enter miles for a single day.
          </>
        ),
        textPosition: "left",
      },
      {
        element: "input_asset",
        text: (
          <>
            <strong>Asset:</strong> In case you have a one-vehicle Asset, or set
            one vehicle as a default asset, it will be automatically populated
            in a field. However, you can choose to select a different Asset from
            the dropdown if needed.
          </>
        ),
        textPosition: "left",
      },
      {
        element: "input_businessMiles",
        text: (
          <>
            <strong>Business Miles:</strong> Enter the number of business miles
            driven for a selected date range.
          </>
        ),
        textPosition: "left",
      },
      {
        element: "input_privateMiles",
        text: (
          <>
            <strong>Private Miles:</strong> Enter the number of private Miles
            driven for a selected date range.
            <br />
            <br />
            <strong>Note:</strong> available only for Business type - 'Driving
            Instructor'
          </>
        ),
        textPosition: "left",
      },
      {
        element: "input_comment",
        text: (
          <>
            <strong>Comment:</strong> You can leave a comment if needed; this
            field is optional.
          </>
        ),
        textPosition: "left",
        textPositionMobile: "top",
      },
      {
        element: "button_saveMileage",
        text: (
          <>
            <strong>Save:</strong> Now you can save the entry.
          </>
        ),
        textPosition: "top",
        textPositionMobile: "top",
      },
    ],
  },
  {
    name: "mileageEditTutorial",
    label: "How to edit a mileage entry?",
    description:
      "Update an existing mileage entry — tax year, date range, asset, miles, or comment.",
    items: [
      {
        element: TUTORIAL_MODAL_WINDOW,
        text: (
          <>
            <div className="text-black-100">
              <strong className="text-300">"Mileage” in the FBTC Portal</strong>
              <br />
              <br />
              To help you get started, we’ve prepared a short tutorial that
              walks you through the process step by step.
              <br />
              <br />
              It’s quick and easy to complete, and will help you make the most
              of the new functionality.
            </div>
          </>
        ),
        modalWindowHeight: "h-1/3",
      },
      {
        element: "tr_mileageTable",
        text: <>Click through an mileage from the grid.</>,
        textPosition: "top",
        textPositionMobile: "top",
        afterClickNext: {
          clickOnElement: true,
        },
      },
      {
        element: "button_editMileage",
        text: (
          <>
            Click the <strong>"Edit Mileage"</strong> button.
          </>
        ),
        textPosition: "top",
        textPositionMobile: "top",
        afterClickNext: {
          clickOnElement: true,
        },
      },
      {
        element: "input_taxYear",
        text: <>Update Tax Year.</>,
      },
      {
        element: "input_dateRange",
        text: <>Update Date Range.</>,
        textPosition: "left",
      },
      {
        element: "input_asset",
        text: <>Update Asset.</>,
        textPosition: "left",
      },
      {
        element: "input_businessMiles",
        text: <>Update Business Miles.</>,
        textPosition: "left",
        textPositionMobile: "top",
      },
      {
        element: "input_privateMiles",
        text: <>Update Private Miles.</>,
        textPosition: "left",
        textPositionMobile: "top",
      },
      {
        element: "input_comment",
        text: (
          <>
            You can leave or update a comment if needed; this field is optional.
          </>
        ),
        textPosition: "left",
        textPositionMobile: "top",
      },
      {
        element: "button_saveMileage",
        text: <>Now you can save the entry.</>,
        textPosition: "top",
        textPositionMobile: "top",
      },
    ],
  },
  {
    name: "mileageDeleteTutorial",
    label: "How to delete a mileage entry?",
    description: "Remove a mileage entry from your log.",
    items: [
      {
        element: TUTORIAL_MODAL_WINDOW,
        text: (
          <>
            <div className="text-black-100">
              <strong className="text-300">"Mileage” in the FBTC Portal</strong>
              <br />
              <br />
              To help you get started, we’ve prepared a short tutorial that
              walks you through the process step by step.
              <br />
              <br />
              It’s quick and easy to complete, and will help you make the most
              of the new functionality.
            </div>
          </>
        ),
        modalWindowHeight: "h-1/3",
      },
      {
        element: "tr_mileageTable",
        text: <>Click through an mileage from the grid.</>,
        textPosition: "top",
        textPositionMobile: "top",
        afterClickNext: {
          clickOnElement: true,
        },
      },
      {
        element: "button_removeMileage",
        text: (
          <>
            Click the <strong>"Delete"</strong> button. Once you have confirmed
            you wish to delete the mileage record, it will disappear from your
            mileage log.
          </>
        ),
        textPosition: "left",
        textPositionMobile: "left",
      },
    ],
  },
  {
    name: "transactionCreateTutorial",
    label: "How to add a transaction?",
    description:
      "Record an income or expense — pick the category, set the date and amount, and attach a receipt if you have one. Takes about a minute.",
    items: [
      {
        element: TUTORIAL_MODAL_WINDOW,
        text: (
          <>
            <div className="text-black-100">
              <strong className="text-300">
                <strong>“Transaction”</strong> in the FBTC Portal
              </strong>
              <br />
              <br />
              To help you get started, we’ve prepared a short tutorial that
              walks you through the process step by step.
              <br />
              <br />
              It’s quick and easy to complete, and will help you make the most
              of the new functionality.
            </div>
          </>
        ),
        modalWindowHeight: "h-1/3",
      },
      {
        element: "button_mobilePlus",
        text: (
          <>
            Click the <strong>"Plus"</strong> button.
          </>
        ),
        textPositionMobile: "top left",
        justForMobile: true,
        afterClickNext: {
          clickOnElement: true,
        },
      },
      {
        element: "button_addTransaction",
        text: (
          <>
            On the main navigation bar, click the{" "}
            <strong>"Add Transaction"</strong> button.
          </>
        ),
        textPosition: "left",
        textPositionMobile: "top",
        afterClickNext: {
          clickOnElement: true,
        },
      },
      {
        element: "input_businessId",
        text: <>Please select the business you wish to add transaction for.</>,
        textPosition: "right",
      },
      {
        element: "input_categoryId",
        text: (
          <>
            Choose a transaction category by searching for a keyword or browsing
            the available options.
          </>
        ),
        textPosition: "right",
      },
      {
        element: "input_date",
        text: (
          <>
            The date is automatically set to today's date, but you can modify
            this, if needed.
          </>
        ),
        textPosition: "right",
      },
      {
        element: "input_amount",
        text: <>Enter an amount for a selected category.</>,
        textPosition: "left",
      },
      {
        element: "input_description",
        text: (
          <>You can provide a description if needed; this field is optional.</>
        ),
        textPosition: "left",
      },
      {
        element: "input_files",
        text: (
          <>You can attach receipts if you have them; this field is optional.</>
        ),
        textPosition: "top",
        textPositionMobile: "top",
      },
      {
        element: "buttons_saveTransaction",
        text: (
          <>
            You can add another transaction by clicking the{" "}
            <strong>"Save and Add Another"</strong> button, or you can click the{" "}
            <strong>"Save Transaction”</strong> button if you are done.
          </>
        ),
        textPosition: "top",
        textPositionMobile: "top",
      },
    ],
  },
  {
    name: "transactionEditTutorial",
    label: "How to edit a transaction?",
    description:
      "Update an existing transaction — available while the status is Open or Re-opened.",
    items: [
      {
        element: TUTORIAL_MODAL_WINDOW,
        text: (
          <>
            <div className="text-black-100">
              <strong className="text-300">
                <strong>“Transaction”</strong> in the FBTC Portal
              </strong>
              <br />
              <br />
              To help you get started, we’ve prepared a short tutorial that
              walks you through the process step by step.
              <br />
              <br />
              It’s quick and easy to complete, and will help you make the most
              of the new functionality.
            </div>
          </>
        ),
        modalWindowHeight: "h-1/3",
      },
      {
        element: "tr_transactionTable",
        text: <>Click on any transaction row.</>,
        textPosition: "top",
        afterClickNext: {
          clickOnElement: true,
        },
      },
      {
        element: "button_editTransaction",
        text: (
          <>
            Click the <strong>"Edit Transaction"</strong> button. You can edit
            any transaction with status <strong>"Open"</strong>.
          </>
        ),
        textPosition: "top",
        textPositionMobile: "top",
        afterClickNext: {
          clickOnElement: true,
        },
      },
      {
        element: "input_businessId",
        text: (
          <>
            You can edit which business the transaction is saved against, if
            needed.
          </>
        ),
        textPosition: "right",
      },
      {
        element: "input_categoryId",
        text: (
          <>
            You can update the transaction category by searching using a keyword
            or browsing the available options.
          </>
        ),
        textPosition: "right",
      },
      {
        element: "input_date",
        text: <>Update the date if needed.</>,
        textPosition: "right",
      },
      {
        element: "input_amount",
        text: <>Update the amount if needed.</>,
        textPosition: "left",
      },
      {
        element: "input_description",
        text: <>Update the description if needed; this field is optional.</>,
        textPosition: "left",
        textPositionMobile: "top",
      },
      {
        element: "input_files",
        text: <>Remove old attachments and upload new ones if needed.</>,
        textPosition: "top",
        textPositionMobile: "top",
      },
      {
        element: "buttons_saveTransaction",
        text: (
          <>
            You can add another transaction by clicking the{" "}
            <strong>"Save and Add Another"</strong> button, or you can click the{" "}
            <strong>"Save Transaction"</strong> button if you are done.
          </>
        ),
        textPosition: "top",
        textPositionMobile: "top",
      },
    ],
  },
  {
    name: "transactionDeleteTutorial",
    label: "How to delete a transaction?",
    description:
      "Remove a transaction from your records. Works on entries with status Open or Re-opened.",
    items: [
      {
        element: TUTORIAL_MODAL_WINDOW,
        text: (
          <>
            <div className="text-black-100">
              <strong className="text-300">
                <strong>“Transaction”</strong> in the FBTC Portal
              </strong>
              <br />
              <br />
              To help you get started, we’ve prepared a short tutorial that
              walks you through the process step by step.
              <br />
              <br />
              It’s quick and easy to complete, and will help you make the most
              of the new functionality.
            </div>
          </>
        ),
        modalWindowHeight: "h-1/3",
      },
      {
        element: "tr_transactionTable",
        text: <>Click on any transaction row.</>,
        textPosition: "top",
        afterClickNext: {
          clickOnElement: true,
        },
      },
      {
        element: "button_removeTransaction",
        text: (
          <>
            Click the <strong>"Remove"</strong> button for deleting this
            transaction. Once you have confirmed you wish to delete the
            transaction, it will disappear from your transaction records.
          </>
        ),
        textPosition: "left",
        textPositionMobile: "left",
      },
      {
        element: "button_addRefund",
        text: (
          <>
            Alternatively, if you want to declare a refund to an existing
            transaction, click the "Add Refund" button at the bottom.
          </>
        ),
        textPosition: "top",
        textPositionMobile: "top",
      },
    ],
  },
  {
    name: "refundCreateTutorial",
    label: "How to add a refund?",
    description:
      "Record a refund — either against an existing transaction or as a new entry if the original purchase wasn’t logged.",
    items: [
      {
        element: TUTORIAL_MODAL_WINDOW,
        text: (
          <>
            <div className="text-black-100">
              <strong className="text-300">
                <strong>“Transaction”</strong> in the FBTC Portal
              </strong>
              <br />
              <br />
              To help you get started, we’ve prepared a short tutorial that
              walks you through the process step by step.
              <br />
              <br />
              It’s quick and easy to complete, and will help you make the most
              of the new functionality.
            </div>
          </>
        ),
        modalWindowHeight: "h-1/3",
      },
      {
        element: "button_mobilePlus",
        text: (
          <>
            Click the <strong>"Plus"</strong> button.
          </>
        ),
        textPositionMobile: "top left",
        justForMobile: true,
        afterClickNext: {
          clickOnElement: true,
        },
      },
      {
        element: "button_topNavAddRefund",
        text: (
          <>
            If you want to declare the refund to transaction that hasn't been
            added to the system, please click <strong>"Add Refund"</strong>.
          </>
        ),
        textPosition: "left",
        textPositionMobile: "top",
        afterClickNext: {
          clickOnElement: true,
        },
      },
      {
        element: "input_businessId",
        text: <>Please select the business you wish to add refund for.</>,
        textPosition: "right",
      },
      {
        element: "input_categoryId",
        text: (
          <>
            Choose transaction category by searching using a keyword or browsing
            the available options.
          </>
        ),
        textPosition: "right",
      },
      {
        element: "input_date",
        text: (
          <>
            The date is automatically set to today's date, you can modify this,
            if needed.
          </>
        ),
        textPosition: "right",
      },
      {
        element: "input_amount",
        text: <>Enter the amount for a selected category.</>,
        textPosition: "left",
      },
      {
        element: "input_description",
        text: (
          <>You can provide a description if needed; this field is optional.</>
        ),
        textPosition: "left",
      },
      {
        element: "input_files",
        text: <>You can attach receipts if you have; this field is optional.</>,
        textPosition: "top",
        textPositionMobile: "top",
      },
      {
        element: "buttons_saveTransaction",
        text: <>Now you can save the entry.</>,
        textPosition: "top",
        textPositionMobile: "top",
      },
    ],
  },
  {
    name: "transactionFindTutorial",
    label: "How to find a transaction?",
    description:
      "Filter the transaction grid by asset, type, or status, and learn what each status means at a glance.",
    items: [
      {
        element: TUTORIAL_MODAL_WINDOW,
        text: (
          <>
            <div className="text-black-100">
              <strong className="text-300">
                <strong>“Transaction”</strong> in the FBTC Portal
              </strong>
              <br />
              <br />
              To help you get started, we’ve prepared a short tutorial that
              walks you through the process step by step.
              <br />
              <br />
              It’s quick and easy to complete, and will help you make the most
              of the new functionality.
            </div>
          </>
        ),
        modalWindowHeight: "h-1/3",
      },
      {
        element: "filter_businessSelector",
        text: <>Please select the business you wish to view an overview for.</>,
        textPosition: "right",
      },
      {
        element: "filter_dateRangeSelector",
        text: <>Please select the period you wish to view an overview for.</>,
        textPosition: "left",
      },
      {
        element: "filter_assetSelector",
        text: <>Please select the asset you wish to view an overview for.</>,
        textPosition: "right",
      },
      {
        element: "filter_categorySelector",
        text: <>Please select the category you wish to view an overview for.</>,
        textPosition: "left",
      },
      {
        element: "filter_filtersSelector",
        text: <>Please select rest filters you wish to view an overview for.</>,
        textPosition: "left",
      },
      {
        element: TUTORIAL_MODAL_WINDOW,
        text: <>Now you can see your filtered results.</>,
        modalWindowHeight: "h-1/6",
      },
    ],
  },
  {
    name: "dashboardViewTutorial",
    label: "How to read your dashboard?",
    description:
      "See your total income, expenses, and profit at a glance, then drill into any card to see the transactions behind the number.",
    items: [
      {
        element: TUTORIAL_MODAL_WINDOW,
        text: (
          <>
            <div className="text-black-100">
              <strong className="text-300">
                <strong>“Dashboard”</strong> in the FBTC Portal
              </strong>
              <br />
              <br />
              To help you get started, we’ve prepared a short tutorial that
              walks you through the process step by step.
              <br />
              <br />
              It’s quick and easy to complete, and will help you make the most
              of the new functionality.
            </div>
          </>
        ),
        modalWindowHeight: "h-1/3",
      },
      {
        element: "filter_businessSelector",
        text: <>Please select the business you wish to view an overview for.</>,
        textPosition: "right",
      },
      {
        element: "filter_dateRangeSelector",
        text: <>Please select the period you wish to view an overview for.</>,
        textPosition: "left",
      },
      {
        element: "filter_assetSelector",
        text: <>Please select the asset you wish to view an overview for.</>,
        textPosition: "left",
      },
      {
        element: "dashboard_totalWidget",
        text: <>See your total income, expenses, and profit at a glance.</>,
        textPosition: "right",
        textPositionMobile: "top",
      },
      {
        element: "thead_dashboardTable",
        text: (
          <>
            View, edit, and check the status of transactions.
            <br />
            <br />
            <strong>Note:</strong> Already submitted transactions can not be
            edited or deleted.
          </>
        ),
        textPosition: "top",
        justForDesktop: true,
      },
      {
        element: "tr_transactionTable",
        text: (
          <>
            View, edit, and check the status of transactions.
            <br />
            <br />
            <strong>Note:</strong> Already submitted transactions can not be
            edited or deleted.
          </>
        ),
        textPositionMobile: "top",
        justForMobile: true,
      },
      {
        element: "dashboard_itemWidget",
        text: <>Click any card to see what's included behind it.</>,
        textPosition: "left",
        textPositionMobile: "top",
        afterClickNext: {
          clickOnElement: true,
        },
      },
      {
        element: "widgetDetails_subcategoryLabel",
        text: (
          <>This panel shows related transactions grouped by subcategories.</>
        ),
        textPosition: "left",
      },
    ],
  },
  {
    name: "submissionViewTutorial",
    label: "How to find a submission?",
    description:
      "Track everything you’ve sent for review — filter by status and open the submission you need.",
    items: [
      {
        element: TUTORIAL_MODAL_WINDOW,
        text: (
          <>
            <div className="text-black-100">
              <strong className="text-300">
                “Submission” in the FBTC Portal.
              </strong>
              <br />
              <br />
              To help you get started, we’ve prepared a short tutorial that
              walks you through the process step by step.
              <br />
              <br />
              It’s quick and easy to complete, and will help you make the most
              of the new functionality.
            </div>
          </>
        ),
        modalWindowHeight: "h-1/3",
      },
      {
        element: "submissions_select_businessId",
        text: <>Please select the business you wish to view an overview for.</>,
        textPosition: "right",
      },
      {
        element: "filter_dateRangeSelector",
        text: <>Please select the period you wish to view an overview for.</>,
        textPosition: "left",
      },
      {
        element: "filter_filtersSelector",
        text: <>You can filter by status.</>,
        textPosition: "left",
      },
      {
        element: "tr_submissionsTable",
        text: <>Now you can see your submissions.</>,
        textPosition: "top",
      },
    ],
  },
  {
    name: "submissionDetailsViewTutorial",
    label: "How to review a submission?",
    description:
      "Open a submission to see its entries and KPIs for the period. Submitted entries are locked and can’t be edited.",
    items: [
      {
        element: TUTORIAL_MODAL_WINDOW,
        text: (
          <>
            <div className="text-black-100">
              <strong className="text-300">
                “Transaction” in the FBTC Portal.
              </strong>
              <br />
              <br />
              To help you get started, we’ve prepared a short tutorial that
              walks you through the process step by step.
              <br />
              <br />
              It’s quick and easy to complete, and will help you make the most
              of the new functionality.
            </div>
          </>
        ),
        modalWindowHeight: "h-1/3",
      },
      {
        element: "tr_submissionsTable",
        text: (
          <>Click through the row to see the the details of the submission.</>
        ),
        textPosition: "top",
        afterClickNext: {
          clickOnElement: true,
        },
      },
      {
        element: "submissionDetails_kpi",
        text: (
          <>
            Here you can see the results of you financial activity for the
            submission period.
          </>
        ),
        textPosition: "top",
      },
      {
        element: "tr_transactionTable",
        text: (
          <>
            These are all the entries included in your submission. You cannot
            edit these entries once your submission has been sent to your
            accountant for approval.
          </>
        ),
        textPosition: "top",
      },
    ],
  },
  {
    name: "privateUseCreateTutorial",
    label: "How to set Private Use?",
    description:
      "Set the Private Use share for each transaction category in the period.",
    items: [
      {
        element: TUTORIAL_MODAL_WINDOW,
        text: (
          <>
            <div className="text-black-100">
              <strong className="text-300">
                “Private Use” in the FBTC Portal.
              </strong>
              <br />
              <br />
              To help you get started, we’ve prepared a short tutorial that
              walks you through the process step by step.
              <br />
              <br />
              It’s quick and easy to complete, and will help you make the most
              of the new functionality.
            </div>
          </>
        ),
        modalWindowHeight: "h-1/3",
      },
      {
        element: "submissions_select_businessId",
        text: <>Please select the business you wish to add private use for.</>,
        textPosition: "right",
      },
      {
        element: "tbody_submissionsTable",
        text: <>Select the period to which the private use relates.</>,
        textPosition: "top",
        afterClickNext: {
          clickOnElement: true,
          elementForClick: "tr_submissionsTable",
        },
      },
      {
        element: "table_privateUseTable",
        text: (
          <div className="leading-[18px]">
            Now you can see all transactions categories for the selected{" "}
            <strong>Period</strong> and can set the{" "}
            <strong>Private Use (PU) share</strong> for each category.
            <br />
            <strong>Note:</strong>
            <br />- For <strong>Driving Instructors</strong>, the{" "}
            <strong>Motor category</strong> may be disabled with a preset PU %
            if you consistently log mileage in <strong>Mileage Log</strong>. To
            change this %, you may need to{" "}
            <strong>add missing mileage data</strong> or{" "}
            <strong>remove existing mileage logs</strong> for that Period. If
            you have <strong>multiple Vehicle Assets</strong>, the PU will{" "}
            <strong>split between them based on transactions</strong>.
            <br />- For <strong>other business types</strong>, if you{" "}
            <strong>claim Mileage</strong> for a Vehicle Asset, the{" "}
            <strong>Motor Expense category will not appear</strong>. However, if
            you <strong>add Motor expense transactions</strong> for that asset,
            you can <strong>enter the Private Use percentage</strong>.
          </div>
        ),
        textPosition: "top",
        textPositionMobile: "top",
        paddingTop: 44,
        maxWidth: "max-w-[900px]",
      },
      {
        element: "table_privateUseTable",
        text: (
          <>
            If you do not add a PU% the system will automatically set it to 0%.
          </>
        ),
        textPosition: "top",
      },
      {
        element: "submitButton_submissionDetails",
        text: (
          <>
            After you entered or reviewed the Private Use log, you can continue
            to submitting data for review. Once submitted, you cannot edit
            anymore.
          </>
        ),
        textPosition: "left",
      },
    ],
  },
  {
    name: "privateUseSimpleCreateTutorial",
    label: "How to set Private Use?",
    description:
      "Set the Private Use share for each transaction category in the period.",
    items: [
      {
        element: TUTORIAL_MODAL_WINDOW,
        text: (
          <>
            <div className="text-black-100">
              <strong className="text-300">
                “Private Use” in the FBTC Portal.
              </strong>
              <br />
              <br />
              To help you get started, we’ve prepared a short tutorial that
              walks you through the process step by step.
              <br />
              <br />
              It’s quick and easy to complete, and will help you make the most
              of the new functionality.
            </div>
          </>
        ),
        modalWindowHeight: "h-1/3",
      },
      {
        element: "table_privateUseTable",
        text: (
          <div className="leading-[18px]">
            Now you can see all transactions categories for the selected{" "}
            <strong>Period</strong> and can set the{" "}
            <strong>Private Use (PU) share</strong> for each category.
            <br />
            <strong>Note:</strong>
            <br />- For <strong>Driving Instructors</strong>, the{" "}
            <strong>Motor category</strong> may be disabled with a preset PU %
            if you consistently log mileage in <strong>Mileage Log</strong>. To
            change this %, you may need to{" "}
            <strong>add missing mileage data</strong> or{" "}
            <strong>remove existing mileage logs</strong> for that Period. If
            you have <strong>multiple Vehicle Assets</strong>, the PU will{" "}
            <strong>split between them based on transactions</strong>.
            <br />- For <strong>other business types</strong>, if you{" "}
            <strong>claim Mileage</strong> for a Vehicle Asset, the{" "}
            <strong>Motor Expense category will not appear</strong>. However, if
            you <strong>add Motor expense transactions</strong> for that asset,
            you can <strong>enter the Private Use percentage</strong>.
          </div>
        ),
        textPosition: "top",
        textPositionMobile: "top",
        paddingTop: 44,
        maxWidth: "max-w-[900px]",
      },
      {
        element: "table_privateUseTable",
        text: (
          <>
            If you do not add a PU% the system will automatically set it to 0%.
          </>
        ),
        textPosition: "top",
      },
      {
        element: "submitButton_submissionDetails",
        text: (
          <>
            After you entered or reviewed the Private Use log, you can continue
            to submitting data for review. Once submitted, you cannot edit
            anymore.
          </>
        ),
        textPosition: "left",
      },
    ],
  },
];
